<template>
    <BaseModal
        :isVisible="modalStatus"
        title="Veículo Retirado"
        size="lg"
        @close="cleanModal"
    >
        <template v-slot:content>
            <div class="retreat-vehicle-details">
                <SectionContainer
                    title="Dados da Reserva"
                    icon="calendar-check"
                >
                    <!-- Header com imagem e informações principais -->
                    <div class="vehicle-header">
                        <div class="row w-100">
                            <div class="col-md-6">
                                <ImageVehicle :vehicle-data="vehicleData"/>
                            </div>
                            <div class="col-md-6">
                                <div class="main-info-section h-100">
                                    <div class="status-row">
                                        <span class="status-badge status-progress">
                                            <i class="fas fa-car"></i>
                                            Veículo Retirado
                                        </span>
                                        <div class="reservation-number">
                                            #{{ reserveData.id }}
                                        </div>
                                    </div>

                                    <div class="vehicle-quick-info">
                                        <h5>{{ vehicleData.description }} - {{ vehicleData.color }}</h5>
                                        <div class="plate-container">
                                            <i class="fas fa-hashtag"></i>
                                            {{ vehicleData.board }}
                                        </div>
                                    </div>

                                    <div class="user-info-compact">
                                        <span class="user-name">
                                            <i class="fas fa-user"></i>
                                            {{ reserveData.user ? reserveData.user.name : 'N/A' }}
                                        </span>
                                        <button
                                            class="btn btn-sm btn-outline-primary"
                                            @click="openModalUser(reserveData)"
                                            title="Dados do Usuário"
                                        >
                                            <i class="fas fa-user"></i>
                                        </button>
                                    </div>

                                    <div class="action-buttons-header mt-auto">
                                        <router-link
                                            :to="'/myreserves/view/' + reserveData.id"
                                            @click="cleanModal"
                                            class="btn btn-outline-info btn-sm"
                                            title="Visualizar Reserva"
                                        >
                                            <i class="fas fa-eye mr-2"></i>
                                            Ver Detalhes
                                        </router-link>
                                        <button
                                            class="btn btn-primary btn-sm"
                                            @click="openModal(reserveData)"
                                            title="Visualizar Check-Out"
                                        >
                                            <i class="fas fa-clipboard-check mr-2"></i>
                                            Check-Out
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Grid de informações compactas -->
                    <div class="info-grid">
                        <div class="info-item">
                            <i class="fas fa-list"></i>
                            <div>
                                <span class="info-label">Tipo:</span>
                                <span class="info-value">
                                    {{ vehicleData.vehicle_type ? vehicleData.vehicle_type.description : 'N/A' }}
                                </span>
                            </div>
                        </div>

                        <div class="info-item">
                            <i class="fas fa-map-marker-alt"></i>
                            <div>
                                <span class="info-label">Cidade Destino:</span>
                                <span class="info-value">{{ getDestinationCity() }}</span>
                            </div>
                        </div>

                        <div class="info-item" v-if="hasRides()">
                            <i class="fas fa-users"></i>
                            <div>
                                <span class="info-label">Caronas:</span>
                                <span class="info-value">{{ getRideNames() }}</span>
                            </div>
                        </div>

                        <div class="info-item">
                            <i class="fas fa-calendar-alt"></i>
                            <div>
                                <span class="info-label">Retirada Estimada:</span>
                                <span class="info-value date-highlight">{{ reserveData.retreat_date }}</span>
                            </div>
                        </div>

                        <div class="info-item">
                            <i class="fas fa-calendar-check"></i>
                            <div>
                                <span class="info-label">Retirado Em:</span>
                                <span class="info-value date-highlight">
                                    {{ reserveData.checkout ? reserveData.checkout.retreat_at : 'N/A' }}
                                </span>
                            </div>
                        </div>

                        <div class="info-item">
                            <i class="fas fa-calendar-times"></i>
                            <div>
                                <span class="info-label">Devolução Estimada:</span>
                                <span class="info-value date-highlight">{{ reserveData.devolution_date }}</span>
                            </div>
                        </div>

                        <div class="info-item" v-if="reserveData.km_traveled">
                            <i class="fas fa-tachometer-alt"></i>
                            <div>
                                <span class="info-label">Km Rodados:</span>
                                <span class="info-value km-value">
                                    {{ formatKilometers(reserveData.km_traveled) }} km
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Ações principais -->
                    <div class="main-actions">
                        <button
                            v-if="canCancelReservation"
                            class="btn btn-danger"
                            @click="cancelReservation(reserveData.id)"
                            title="Cancelar Reserva"
                        >
                            <i class="fas fa-times mr-2"></i>
                            Cancelar Reserva
                        </button>

                        <button
                            class="btn btn-outline-info"
                            @click="showMessageForm = !showMessageForm"
                            title="Enviar Notificação"
                        >
                            <i class="fas fa-bell mr-2"></i>
                            Enviar Notificação
                        </button>
                    </div>

                    <!-- Formulário de mensagem -->
                    <div v-if="showMessageForm" class="message-section">
                        <SectionContainer
                            title="Enviar Notificação"
                            icon="bell"
                        >
                            <div class="message-form">
                                <div class="form-group">
                                    <label for="messageInput">Mensagem:</label>
                                    <textarea
                                        id="messageInput"
                                        v-model="messageText"
                                        class="form-control"
                                        rows="3"
                                        placeholder="Digite sua mensagem..."
                                    ></textarea>
                                </div>
                                <div class="message-actions">
                                    <button
                                        class="btn btn-secondary"
                                        @click="showMessageForm = false"
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        class="btn btn-success"
                                        @click="submitMessage(reserveData.user_id, reserveData.id)"
                                    >
                                        <i class="fas fa-paper-plane mr-2"></i>
                                        Enviar
                                    </button>
                                </div>
                            </div>
                        </SectionContainer>
                    </div>
                </SectionContainer>
            </div>

            <!-- Histórico de Viagens -->
            <LastTripsTable
                :vehicle-data="vehicleData"
                :total-trips="totalTrips"
                :pagination-options="paginationOptions"
                @open-trip-details="openModal"
                @load-page="paginate"
            />
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from '../Base/BaseModal.vue'
import SectionContainer from "./Checklist/SectionContainer.vue"
import LastTripsTable from "./Components/LastTripsTable.vue"
import ImageVehicle from "./Components/ImageVehicle.vue"
import { getMessage } from "../../composables/message"

export default {
    name: "RetreatVehicleModal", // Nome do componente: Modal de Veículo Retirado
    components: {
        BaseModal,
        SectionContainer,
        LastTripsTable,
        ImageVehicle
    },
    props: {
        modalStatus: { // modalStatus - status do modal se está aberto ou fechado
            type: Boolean,
            default: false
        },
        dataModal: { // dataModal - dados do veículo a serem exibidos no modal
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            showMessageForm: false, // showMessageForm - controla a exibição do formulário de mensagem
            messageText: '', // messageText - texto da mensagem para notificação
            paginationOptions: { // paginationOptions - opções de configuração da paginação
                texts: {
                    count: "Mostrando {from} de {to} até {count} de registros",
                },
                page: 1,
                chunk: 4,
                chunksNavigation: "fixed",
            }
        }
    },
    computed: {
        vehicleData() { // vehicleData - dados do veículo computados a partir do dataModal
            return this.dataModal || {}
        },
        reserveData() { // reserveData - dados da reserva do veículo
            return this.vehicleData.reserve_vehicle && this.vehicleData.reserve_vehicle[0]
                ? this.vehicleData.reserve_vehicle[0]
                : {}
        },
        totalTrips() { // totalTrips - total de viagens para controle da paginação
            return this.vehicleData.lastTrips ? this.vehicleData.lastTrips.total : 0
        },
        canCancelReservation() { // canCancelReservation - verifica se o usuário pode cancelar a reserva
            const userAccessLevel = this.$store.state.user.access_nivel
            return userAccessLevel === '3' || userAccessLevel === '4'
        }
    },
    watch: {
        modalStatus(newStatus) { // modalStatus - observa mudanças no status do modal
            if (!newStatus) {
                this.cleanModal()
            }
        }
    },
    methods: {
        formatKilometers(value) { // formatKilometers - formata o valor de quilometragem com pontos
            if (!value) return '0'
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },
        getDestinationCity() { // getDestinationCity - obtém o nome da cidade de destino
            const reserve = this.reserveData
            if (reserve && reserve.city_destination && reserve.city_destination.city_destination) {
                return reserve.city_destination.city_destination.description
            }
            return 'N/A'
        },
        hasRides() { // hasRides - verifica se há caronas na reserva
            return this.reserveData.ride && this.reserveData.ride.length > 0
        },
        getRideNames() { // getRideNames - obtém os nomes das pessoas nas caronas
            if (!this.hasRides()) return ''
            return this.reserveData.ride
                .filter(ride => ride && ride.requester)
                .map(ride => ride.requester.name)
                .join(', ')
        },
        paginate(page) { // paginate - controla a paginação das viagens
            this.$emit("openModals", this.vehicleData.id, this.vehicleData.status, this.vehicleData, page)
        },
        openModal(object) { // openModal - abre modal de detalhes de viagem ou checkout
            this.$emit("OMDCk", object)
        },
        openModalUser(object) { // openModalUser - abre modal do usuário
            this.$emit("OpenModalUser", object)
        },
        cancelReservation(id) { // cancelReservation - cancela a reserva
            this.saveReservationCancellation(id)
        },
        saveReservationCancellation(id) { // saveReservationCancellation - salva o cancelamento da reserva via API
            const api = this.$store.state.api + "reserveVehicles/" + id
            const formData = new FormData()

            formData.append("_method", "PATCH")
            formData.append("observation", "Cancelado via Portal Admin")
            formData.append("reserve_status", "3")

            swal({
                title: "Deseja cancelar a reserva?",
                text: "Essa operação não pode ser desfeita",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, cancelar!",
                showLoaderOnConfirm: true,
                buttons: {
                    catch: {
                        text: "Não",
                        value: "cancel",
                        className: "btn-danger",
                    },
                    confirm: {
                        text: "Sim",
                        value: "confirm",
                    },
                },
            })
                .then((value) => {
                    switch (value) {
                        case "cancel":
                            swal("Operação Encerrada", "A reserva não foi cancelada!", "info")
                            break
                        case "confirm":
                            this.$http.post(api, formData).then((response) => {
                                swal("Sucesso", "Reserva cancelada com sucesso!", "success")
                                setTimeout(() => {
                                    location.reload()
                                }, 1000)
                            })
                            break
                    }
                })
                .catch((error) => {
                    const message = error.response.data.errors
                        ? getMessage(error.response.data.errors)
                        : error.response.data
                    this.$message(null, message, "error")
                })
        },
        submitMessage(userId, reserveId) { // submitMessage - envia notificação personalizada
            if (!this.messageText || this.messageText.trim() === '') {
                this.$message(null, 'Preencha o campo Mensagem!', "error")
                return
            }

            const formData = {
                user_id: userId,
                reserve_id: reserveId,
                message: this.messageText
            }

            const api = this.$store.state.api + "reserveVehicle/notifications"

            this.$http.post(api, formData).then(() => {
                swal("Sucesso", "Notificação enviada com sucesso!", "success")
                this.messageText = ''
                this.showMessageForm = false
            })
        },
        cleanModal() { // cleanModal - limpa dados e fecha o modal
            this.showMessageForm = false
            this.messageText = ''
            this.$emit("changeModal", false)
        }
    }
}
</script>

<style scoped>
.retreat-vehicle-details {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Header com imagem e informações principais */
.vehicle-header {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 15px;
}

.main-info-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 100%;
}

.status-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.status-badge {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: bold;
    display: inline-flex;
    align-items: center;
    gap: 5px;
}

.status-progress {
    background-color: #cce5ff;
    color: #004085;
}

.reservation-number {
    font-size: 18px;
    font-weight: bold;
    color: #6c757d;
}

.vehicle-quick-info h5 {
    margin: 0 0 8px 0;
    color: #495057;
    font-size: 16px;
}

.plate-container {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background-color: #f8981d;
    color: white;
    padding: 4px 10px;
    border-radius: 4px;
    font-weight: bold;
    font-size: 14px;
}

.user-info-compact {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.user-name {
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: 600;
    color: #495057;
}

.action-buttons-header {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.action-buttons-header .btn {
    flex: 1;
    min-width: 120px;
}

/* Grid de informações compactas */
.info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 15px;
    margin-bottom: 20px;
}

.info-item {
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: #f8f9fa;
    padding: 12px;
    border-radius: 6px;
    border-left: 4px solid #f8981d;
}

.info-item i {
    color: #f8981d;
    font-size: 16px;
    width: 20px;
    text-align: center;
}

.info-item div {
    flex: 1;
}

.info-label {
    display: block;
    font-size: 12px;
    color: #6c757d;
    margin-bottom: 2px;
}

.info-value {
    display: block;
    font-weight: 600;
    color: #2c3e50;
}

.date-highlight {
    color: #f8981d !important;
}

.km-value {
    color: #0056b3 !important;
}

/* Ações principais */
.main-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-bottom: 15px;
    flex-wrap: wrap;
}

.main-actions .btn {
    min-width: 150px;
    width: auto;
}

/* Seção de mensagem */
.message-section {
    background-color: #fff3cd;
    border-radius: 6px;
    padding: 15px;
    margin-top: 15px;
}

.message-form {
    background-color: white;
    padding: 15px;
    border-radius: 6px;
}

.message-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 15px;
}

/* Responsividade */
@media (max-width: 768px) {
    .vehicle-header {
        flex-direction: column;
    }

    .status-row {
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
    }

    .info-grid {
        grid-template-columns: 1fr;
    }

    .main-actions {
        justify-content: center;
        flex-direction: column;
    }

    .action-buttons-header .btn {
        width: 100%;
        margin-bottom: 5px;
    }

    .user-info-compact {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .message-actions {
        flex-direction: column;
    }

    .message-actions .btn {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/RetreatModal.vue